/**
 * Base URL for the Mindy PHP chat API (POST /chat).
 *
 * Empty → same-origin `/chat` (SPA and API share one hostname; docroot = api/public).
 * Override when the API lives elsewhere:
 *   REACT_APP_MINDY_API_URL=https://api.example.com/chat
 * Local dev API on another port:
 *   REACT_APP_MINDY_API_URL=http://127.0.0.1:8080/chat
 */
const raw =
  typeof process !== "undefined" && process.env.REACT_APP_MINDY_API_URL
    ? process.env.REACT_APP_MINDY_API_URL.trim()
    : "";

/** Trailing slash normalized away; relative paths like `/chat` stay relative (same browser origin). */
export const MINDY_API_URL = raw.replace(/\/+$/, "") || "/chat";
